export default function mixin (...mixins) {
  return (
    mixins
      .reverse()
      .reduce((base, extend) => extend(base))
  )
};



// WEBPACK FOOTER //
// ../webmango-utils/mixin.js